/**
 * Article page helpers (sections/voge-article.liquid):
 * - table of contents: open as a sidebar on desktop, collapsible on mobile, highlights the current H2
 * - copy-link share button (Clipboard API with a fallback)
 * - wraps wide tables in a horizontally scrollable container
 */
const DESKTOP = window.matchMedia('(min-width: 990px)');

function initToc() {
  const toc = /** @type {HTMLDetailsElement | null} */ (document.querySelector('[data-voge-toc]'));
  if (!toc) return;

  const sync = () => {
    toc.open = DESKTOP.matches;
  };
  sync();
  DESKTOP.addEventListener('change', sync);

  const links = /** @type {HTMLAnchorElement[]} */ (Array.from(toc.querySelectorAll('[data-toc-link]')));
  const headings = links
    .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
    .filter((heading) => heading instanceof HTMLElement);

  toc.addEventListener('click', (event) => {
    const link = /** @type {HTMLElement} */ (event.target).closest('[data-toc-link]');
    if (link && !DESKTOP.matches) toc.open = false;
  });

  if (!('IntersectionObserver' in window) || headings.length === 0) return;

  /** @param {string} id */
  const setCurrent = (id) => {
    for (const link of links) {
      if (decodeURIComponent(link.hash.slice(1)) === id) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    }
  };

  const observer = new IntersectionObserver(
    () => {
      // The current section is the last heading that has scrolled past the top band.
      let current = headings[0];
      for (const heading of headings) {
        if (heading && heading.getBoundingClientRect().top <= window.innerHeight * 0.3) current = heading;
      }
      if (current) setCurrent(current.id);
    },
    { rootMargin: '0px 0px -60% 0px', threshold: [0, 1] }
  );
  headings.forEach((heading) => heading && observer.observe(heading));
}

function initCopy() {
  const button = /** @type {HTMLButtonElement | null} */ (document.querySelector('[data-share-copy]'));
  if (!button) return;
  const label = button.querySelector('[data-share-copy-label]');
  const status = document.querySelector('[data-share-status]');
  const original = label?.textContent || '';
  let timer = 0;

  button.addEventListener('click', async () => {
    const url = button.dataset.url || window.location.href;
    let ok = false;
    try {
      await navigator.clipboard.writeText(url);
      ok = true;
    } catch {
      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      try {
        ok = document.execCommand('copy');
      } catch {
        ok = false;
      }
      field.remove();
    }
    if (!ok) {
      window.prompt('', url);
      return;
    }
    const copied = button.dataset.copiedText || '';
    if (label) label.textContent = copied;
    if (status) status.textContent = copied;
    button.dataset.state = 'copied';
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (label) label.textContent = original;
      if (status) status.textContent = '';
      delete button.dataset.state;
    }, 2000);
  });
}

function wrapTables() {
  for (const table of document.querySelectorAll('[data-voge-prose] table')) {
    if (table.parentElement?.classList.contains('voge-prose__table')) continue;
    const wrapper = document.createElement('div');
    wrapper.className = 'voge-prose__table';
    wrapper.tabIndex = 0;
    table.before(wrapper);
    wrapper.append(table);
  }
}

wrapTables();
initToc();
initCopy();
